/* eslint-disable linebreak-style */
import { Component, Input } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { PurchaseOrderService } from '../purchase-order.service';
import { ProviderSelected } from 'src/app/pages/gestion/providers/components/details/provider-details.component';

import { CartPurchaseOrderService } from '../utils-components/cart/cart-purchase-order.service';
import { ProductsPurchaseOrderBody } from '../purchase-order.interface';
import { MessageService } from 'primeng/api';
import { UpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.template';
import { IUpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.interface';

@Component({
  selector: 'pg-purchase-order-update',
  templateUrl: './purchase-order-update.component.html',
  providers: [MessageService]
})
export class PurchasesOrderUpdateComponent
  extends UpdateTemplate
  implements IUpdateTemplate
{
  @Input() prueba: number;
  @Input() dataDocumentEdit: any;
  changeForm = false;
  input = true;
  providerSelected = new ProviderSelected('Proveedor');
  PAYMENT_TERMS_NAMES_FOR_DROPDOWN = [
    { label: 'A', value: 1 },
    { label: 'B', value: 2 }
  ];
  TAX_NAMES_FOR_DROPDOWN = [
    { label: 'A', value: 1 },
    { label: 'B', value: 2 }
  ];
  data = {};
  data2 = {};
  payload = {};
  newItems = [];
  newItem = {};
  constructor(
    private fb: FormBuilder,
    private serviceBaseJoin: PurchaseOrderService,
    private cartPurchaseOrderService: CartPurchaseOrderService,
    private messageService: MessageService
  ) {
    super('', serviceBaseJoin);
  }

  ngOnInit(): void {
    const item = this.dataDocumentEdit;

    this.data = {};
    this.data['id'] = item.providerId;
    this.data['name'] = item.providerName;
    this.data['productOfProviderId'] = item.id;
    this.providerSelected.setId(this.data);
    this.row = item;
    this.fg = this.fb.group({
      delivery_at: [item.delivery_at.substr(0, 10), [Validators.required]],
      paymentTerms: [item.paymentTermsId, [Validators.required]],
      numberDocument: [item.numberDocument, [Validators.required]],
      tax: [item.taxId, [Validators.required]]
    });

    this.newItems = [];

    for (const product of item.products) {
      this.newItem = {};
      this.newItem = product;
      this.newItem['discount'] = Number(product.discount);
      this.newItem['grossTotal'] = Number(product.grossTotal);
      this.newItem['netTotal'] = Number(product.netTotal);
      this.newItem['unitPrice'] = Number(product.unitPrice);
      this.newItem['tax'] = Number(product.tax);
      this.newItem['totalTax'] = Number(product.totalTax);
      this.newItem['description'] = product.name;
      this.newItem['unitMeasureDescription'] = product.unitMeasure;
      this.newItems.push(this.newItem);
    }
    this.cartPurchaseOrderService.addGroup(this.newItems);
  }

  async onSubmit() {
    const productsPayload: ProductsPurchaseOrderBody[] =
      this.buildProductsBody();

    for (const value of Object.values(this.fg.value)) {
      if (value == null || value == '' || value == undefined) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Campos sin completar',
          detail: 'Recuerda completar los campos de Detalles'
        });
        return;
      }
    }
    if (this.providerSelected.getId() == null) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Proveedor no seleccionado',
        detail: 'Recuerda seleccionar al Proveedor'
      });
      return;
    }
    if (productsPayload.length == 0) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Carrito vacio',
        detail: 'Recuerda incluir los Productos del Proveedor'
      });
      return;
    }
    this.payload = {
      document: {
        delivery_at: this.fg.value['delivery_at'] + 'T05:00:00.000Z',
        providerId: this.providerSelected.getId(),
        paymentTermsId: this.fg.value['paymentTerms'],
        taxId: this.fg.value['tax'],
        numberDocument: this.fg.value['numberDocument'],
        orderStatusId: 1,
        receptionStatusId: 1,
        invoiceStatusId: 1
      }
    };
    this.payload['products'] = productsPayload;
    this.updateItem$(this.payload);
  }

  buildProductsBody(): ProductsPurchaseOrderBody[] {
    const cartData = this.cartPurchaseOrderService.getData();
    const productsOrderedBody = cartData.map((purchaseOrder) => {
      if (!purchaseOrder.productOfProviderId) {
        purchaseOrder['productOfProviderId'] = purchaseOrder.id;
      }
      return {
        productOfProviderId: purchaseOrder.productOfProviderId,
        name: purchaseOrder.description,
        unitMeasure: purchaseOrder.unitMeasureDescription,
        quantity: Number(purchaseOrder.quantity),
        quantity_rejected: 0,
        quantity_received: 0,
        quantity_invoiced: 0,
        unitPrice: Number(purchaseOrder.unitPrice),
        discount: Number(purchaseOrder.discount),
        netTotal: Number(purchaseOrder.netTotal),
        tax: Number(purchaseOrder.tax),
        totalTax: Number(purchaseOrder.totalTax),
        grossTotal: Number(purchaseOrder.grossTotal)
      };
    });

    return productsOrderedBody;
  }

  isCartEmpty() {
    return this.cartPurchaseOrderService.isCartEmpty();
  }

  ngOnDestroy() {
    this.cartPurchaseOrderService.emptyData();
  }
}
